import React from 'react';
import { connect } from 'react-redux';
import { TableColumn } from 'types';

type TableCellProps = ReturnType<typeof mapStateToProps> & {
  column: TableColumn;
  rowData: any;
  rowIndex: number;
  loading?: boolean;
};

const TableCell: React.FC<TableCellProps> = ({ column, rowData, loading, rowIndex }) => {
  const { render, onClick } = column;
  
  return (
    <td
      className={`whitespace-nowrap text-sm mobile:text-xs font-medium text-gray-900 ${loading && rowIndex < 3 ? 'p-3' : ''}`}
      onClick={onClick}
    >
      {loading
        ? rowIndex < 3 && <div className='p-4 rounded-md animate-pulse bg-gray-300'></div>
        : render(rowData)
      }
    </td>
  );
};

const mapStateToProps = (state: any) => ({
  darkMode: state.app.darkMode
});

export default connect(mapStateToProps)(TableCell);